import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import { createCoeffAbattKm, findCoeffAbattKm, listCoeffAbattKm, updateCoeffAbattKm } from "./coeffAbattKmService";

const coeffAbattKmSlice = createModule({
    name: "coeffAbattKm",
    initialState: {
        coeffsKm: [],
        isFetching: false,
        error: null
    },
    reducers: {
        listCoeffAbattKm: (state) => {
            state.isFetching = true;
        },
        findCoeffAbattKm: (state) => {
            state.isFetching = true;
        },
        createCoeffAbattKm: (state) => {
            state.isFetching = true;
        },
        updateCoeffAbattKm: (state) => {
            state.isFetching = true;
        },
        fetchedData: (state, payload) => {
            state.coeffsKm = payload.body;
        },
        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state) => {
            state.isFetching = false;
            state.error = "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.findCoeffAbattKm]({payload}) {
            try {
                const {data} = yield findCoeffAbattKm(payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.createCoeffAbattKm]({payload}) {
            try {
                console.log(payload.data);
                yield createCoeffAbattKm(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.listCoeffAbattKm]() {
            try {
                const { data } = yield listCoeffAbattKm();
                console.log(data)
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.updateCoeffAbattKm]({payload}) {
            try {
                yield updateCoeffAbattKm(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        }
    })
});

export default coeffAbattKmSlice;
export const coeffAbattKmActions = coeffAbattKmSlice.actions;
